module.exports = __webpack_public_path__ + "assets/img/LTC025.a6af30c0.png";